import { filter as _filter } from 'lodash';

const franchiseeFilter = <T>(data: T[], franchiseeId: string | undefined, locale: string) => _filter(data, (node: any) => node.franchisee.originalId === franchiseeId && node.locale === locale)[0];

export const franchiseeFilterList = <T>(data: T[], franchiseeId: string | undefined, locale: string) => _filter(data, (node: any) => node.franchisee.originalId === franchiseeId && node.locale === locale);

export default franchiseeFilter;
